// reducer.js
import {
  FETCH_KYB_DETAIL_REQUEST,
  FETCH_KYB_DETAIL_SUCCESS,
  FETCH_KYB_DETAIL_FAILURE,
} from "../types";

const initialState = {
  kycDetail: null,
  loading: false,
  error: null,
};

const kycReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_KYB_DETAIL_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_KYB_DETAIL_SUCCESS:
      return {
        ...state,
        kybDetail: action.payload,
        loading: false,
      };
    case FETCH_KYB_DETAIL_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    default:
      return state;
  }
};

export default kycReducer;
